// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/deprecate-formik
import { useFormik } from 'formik'
import * as Yup from 'yup'

import { reportClientError } from '../../../../../../app/_components/chrome/scripts/DataDogRumScript'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { useWaitlistModal } from '../WaitlistModal'

interface IFormValues
  extends Readonly<{
    emailAddress: string
  }> {}

export function useWaitlistForm() {
  const { waitlist: waitlistCopy } = useTranslation()
  const { variantShopifyId, sendWaitlistRequest, setErrorMessage, setSuccessMessage } =
    useWaitlistModal()

  const validationSchema = Yup.object().shape({
    emailAddress: Yup.string()
      .email(waitlistCopy.modal.form.email.validEmailMessage)
      .required(waitlistCopy.modal.form.email.requiredMessage),
  })

  const formik = useFormik<IFormValues>({
    initialValues: {
      emailAddress: '',
    },
    onSubmit: async formValues => {
      if (!variantShopifyId) {
        reportClientError({
          error: new Error(`Shopify variant gid missing.`),
          context: {
            scope: 'WaitlistModal onSubmit',
          },
        })
        return setErrorMessage(waitlistCopy.modal.errorMessage.unexpectedError)
      }
      const waitlistRequestResult = await sendWaitlistRequest({
        email: formValues.emailAddress,
        variantShopifyId,
      })

      switch (waitlistRequestResult) {
        case 'email-already-registered':
          return setErrorMessage(waitlistCopy.modal.errorMessage.emailAlreadyRegistered)
        case 'unexpected-error':
          return setErrorMessage(waitlistCopy.modal.errorMessage.unexpectedError)
        case 'success':
          return setSuccessMessage(waitlistCopy.modal.successMessage)
      }
    },
    validationSchema,
  })

  return formik
}
